import axios from "axios";

const instance = axios.create({
    baseURL: process.env.NODE_ENV === "development" ? 'http://127.0.0.1:8080/api/' : 'https://joshirando.de/api/',
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json',
    }
});

instance.defaults.withCredentials = true;
instance.defaults.xsrfCookieName = "joshirando_xsrf";
instance.defaults.xsrfHeaderName = "x-csrf-token";

instance.interceptors.response.use(function (response) {
    if (response.headers["x-csrf-token"]) {
        instance.defaults.headers["x-csrf-token"] = response.headers["x-csrf-token"];
    }

    return response;
}, function (error) {
    return Promise.reject(error);
});

export default instance;